import React, { useEffect } from 'react';
import './style.scss';
import { HashLink } from 'react-router-hash-link';
import { Drawer, List, ListItem, ListItemIcon } from '@mui/material';
import { Box } from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';

const gonggi = "https://m.blog.naver.com/3652275?categoryNo=6&listStyle=post&proxyReferer=https%3A%2F%2Fm.search.naver.com%2Fsearch.naver%3Fsm%3Dmtp_sly.hst%26where%3Dm%26query%3D%25EB%25B0%2594%25EB%25A5%25B8%25EC%25A0%2595%25ED%2594%258C%25EB%259E%2580%25ED%258A%25B8%25EC%25B9%2598%25EA%25B3%25BC%26acr%3D1/#postlist_block";

const MobileHeader = () => {
    const [state, setState] = React.useState(false);
    const [navbar, setNavar] = React.useState(false);

    const toggleDrawer = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
          return;
        }
    
        setState(open);
      };
    
    const list = () => (
        <Box
          sx={{ width:  300 }}
          role="presentation"
          onClick={toggleDrawer(false)}
          onKeyDown={toggleDrawer(false)}
        >
          <List>
              <ListItem style={{display: "flex", justifyContent: "space-between"}}>
                <a href="/">
                  <img className="logo-in-drawer" src="/img/m-title-grey.png" />
                </a>
                <ListItemIcon className="close-icon" onClick={toggleDrawer(false)} >
                    <CloseIcon sx={{fontSize: 36}} />
                </ListItemIcon>
              </ListItem>
              <ListItem button style={{borderBottom: '1px solid #EAEAEA'}} >
                <HashLink smooth to="/#top" className="m-link">홈</HashLink>
              </ListItem>
              <ListItem button style={{borderBottom: '1px solid #EAEAEA'}}>
                <HashLink smooth to="/#doctor" className="m-link">의료진 소개</HashLink>
              </ListItem>
              <ListItem button style={{borderBottom: '1px solid #EAEAEA'}}>
                <HashLink smooth to="/#subject" className="m-link">진료과목</HashLink>
              </ListItem>
              <ListItem button style={{borderBottom: '1px solid #EAEAEA'}}>
                <HashLink smooth to="/#special" className="m-link">바른정의 특별함</HashLink>
              </ListItem>
              <ListItem button style={{borderBottom: '1px solid #EAEAEA'}}>
                <HashLink smooth to="/#info" className="m-link">진료 안내</HashLink>
              </ListItem>
              <ListItem button style={{borderBottom: '1px solid #EAEAEA'}}>
                <a onClick={()=> {
                    window.open(gonggi,"_blank");
                }} className="m-link">공지사항</a>
              </ListItem>
              <ListItem button style={{borderBottom: '1px solid #EAEAEA'}}>
                <HashLink smooth to="/#location" className="m-link">오시는 길</HashLink>
              </ListItem>
          </List>
          <div className="drawer-sns-cn">
              <img
                src="/img/kakaotalk.png"
                onClick={()=>{
                    window.open(
                        "https://pf.kakao.com/_NDapV",
                        "_blank"
                    );
                }}
                />
              <img
                src="/img/blog.png" 
                onClick={()=>{
                    window.open(
                        "https://blog.naver.com/3652275",
                        "_blank"
                    );
                }}
                />
              <img
                src="/img/insta.png"
                onClick={()=>{
                    window.open(
                        "https://www.instagram.com/baren_jung_plant_dental_clinic/",
                        "_blank"
                    );
                }}
                />
              <img
                src="/img/facebook@2x.png"
                onClick={()=>{
                    window.open(
                        "https://ko-kr.facebook.com/bj2275/",
                        "_blank"
                    );
                }}
                />
          </div>

        </Box>
      );

    const changeBackground = () => {
      if(window.scrollY >= 100) {
        setNavar(true);
      } else {
        setNavar(false);
      }

    };

    const tel = () => {
      document.location.href='tel:051-365-2275'
    }

    useEffect(() => {
      window.addEventListener("scroll", changeBackground);

    })
    return (
        <header>
            {navbar ? (
              <div className="m-title-header active">
                <div className="drawer-logo-cn" onClick={toggleDrawer(true)}>
                    <img className="drawer-logo" src="/img/m-menu-grey-left.png" />
                </div>
                <div className="title-cn">
                    <img className="title" src="/img/m-title-grey.png" />
                </div>
                <div className="phone-cn" onClick={tel}>
                  <img className="phone" src="/img/m-phone-grey.png" />
                </div>
            </div>
            ): (
              <div className="m-title-header">
                <div className="drawer-logo-cn" onClick={toggleDrawer(true)}>
                    <img className="drawer-logo" src="/img/m-menu-white-left.png" />
                </div>
                <div className="title-cn">
                    <img className="title" src="/img/m-title-white.png" />
                </div>
                <div className="phone-cn" onClick={tel}>
                  <img className="phone" src="/img/m-phone.png" />
                </div>
            </div>
            )}

            {/* <img className="m-img-header" src="/img/mobile_1.jpg" /> */}
            <Drawer
                open={state}
                onClose={toggleDrawer(false)}
            >
                {list()}
            </Drawer>
        </header>
    );
};

export default MobileHeader;